import { z } from 'zod';
import { AT_LEAST_ONE_PROPERTY_MESSAGE } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
import { tradeEmbargoStatesPartialSchema, tradeEmbargoStatesSchema } from './TradeEmbargoState.ts';
import { tradeClosedOffersPartialSchema, tradeClosedOffersSchema } from './TradeOfferClosedState.ts';
import { tradeActiveOffersPartialSchema, tradeActiveOffersSchema } from './TradeOfferState.ts';
export const tradeStateSchema = z.object({
    activeOffers: tradeActiveOffersSchema.readonly(),
    closedOffers: tradeClosedOffersSchema.readonly(),
    embargoState: tradeEmbargoStatesSchema.readonly()
}).strict();
export function validateTradeState(data) {
    return validateState(tradeStateSchema, data);
}
export const tradeStatePartialSchema = z.object({
    activeOffers: tradeActiveOffersPartialSchema.readonly(),
    closedOffers: tradeClosedOffersPartialSchema.readonly(),
    embargoState: tradeEmbargoStatesPartialSchema.readonly()
}).partial().strict().refine((obj)=>Object.keys(obj).length > 0, {
    message: AT_LEAST_ONE_PROPERTY_MESSAGE
});
export function validateTradeStatePartial(data) {
    return validateState(tradeStatePartialSchema, data);
}
